import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NotificationMessage } from '../model/notification-message.model';
import { AuthService } from 'src/app/auth/auth.service';
import { NotificationProviderService } from './notification-provider.service';

@Injectable({
    providedIn: 'root'
})
export class NotificationHubService {
    private connection: signalR.HubConnection;
    private token: string;
    public onNotificationRecived: Subject<NotificationMessage> = new Subject<NotificationMessage>();

    constructor(private authService: AuthService, private service: NotificationProviderService) {
        Object.defineProperty(WebSocket, 'OPEN', { value: 1, });

        authService.currentUser.subscribe(user => {
            this.token = user ? this.authService.getToken() : null;
            this.rebuildConnection();
        });
    }

    private async initConnection() {
        let options: signalR.IHttpConnectionOptions = {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets,
            withCredentials: true,
            accessTokenFactory: () => this.token,
        };

        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(environment.notificationHubUrl, options)
            .configureLogging(signalR.LogLevel.Information)
            .build();

        this.connection.onclose(async () => {
            await this.connect();
        });

        this.initMethods();

        await this.connect();
    }

    private async rebuildConnection() {
        if (this.connection?.state === signalR.HubConnectionState.Connected)
            await this.disconnect();

        await this.initConnection();
    }

    public async connect() {
        try {
            await this.connection.start();
            console.log('connected');
        } catch (err) {
            console.log(err);
            setTimeout(() => this.connect(), 5000);
        }
    }

    public async disconnect() {
        await this.connection?.stop();
    }

    public registerMethod(methodName: string, callback: (data: any) => unknown): void {
        this.connection.on(methodName, callback);
    }

    public callNotification(methodName: string, ...params): void {
        this.connection.invoke(methodName, ...params);
        // return defer(() => );
    }

    private initMethods() {
        this.registerMethod('MessageReceiver', (data: any) => {
            this.service.notify(data);
            this.onNotificationRecived.next(data);
        });
    }
}
